import React from "react";
//#region types
import { TodoChipProps } from "models/propTypes/todoPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import UrgencyIndicator from "../urgencyIndicator";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const TodoChip: React.FC<TodoChipProps> = (props) => {
  const { todoInfo } = props;

  return (
    <Grid className={cssExports.todoChipGrid}>
      <UrgencyIndicator urgency={todoInfo?.urgency} />
      <Grid>
        <Grid className={cssExports.todoChipInfoGridRow}>
          <Grid item className={clsx(cssExports.title, cssExports.contentLeft)}>
            {todoInfo?.title}
          </Grid>
          <Grid item className={clsx(cssExports.title, cssExports.contentRight)}>
            {todoInfo?.primaryInfo}
          </Grid>
        </Grid>
        <Grid className={cssExports.todoChipInfoGridRow}>
          <Grid item className={clsx(cssExports.subText, cssExports.contentLeft)}>
            {todoInfo?.subText}
          </Grid>
          <Grid item className={clsx(cssExports.subText, cssExports.contentRight)}>
            {todoInfo?.date ? LocalizationHelperInstance.getFormattedDate(todoInfo?.date) : " "}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TodoChip;
